import { Injectable, inject } from "@angular/core";
import { Observable } from "rxjs";
import { ApiClientService } from "~app/common/services/api-client.service";
import { Utils } from "~app/common/services/utils";
import { IHandelssortimentSearchParamsModel, ISearchHandelssortimentModel } from "~app/features/forsaljning/handelssortiment/handelssortiment.models";

@Injectable({
    providedIn: "root"
})

export class HandelssortimentSearchService {
    private readonly apiClientService = inject(ApiClientService);

    search(handelssortimentSearchParams: IHandelssortimentSearchParamsModel): Observable<ISearchHandelssortimentModel[]> {
        return this.apiClientService.get<ISearchHandelssortimentModel[]>("handelssortiment", false, handelssortimentSearchParams);
    }

    download(handelssortimentBeteckningar: string[], viol3: boolean, format: "combinedfdi" | "env" | "singlefdi", filnamnsprefix: string): Observable<any> {
        return new Observable(observer => {
            this.apiClientService.postRaw(`aptering/fdi/download`, {
                handelssortimentBeteckningar: handelssortimentBeteckningar,
                viol3: viol3,
                format: format
            }, false, { responseType: "text" })
                .subscribe(
                    {
                        next: (data) => {
                            const viol3Ext = viol3 ? "V3" : "";
                            const fileExtension = format === "env" ? "env" : "fdi";
                            Utils.download(data, `${viol3Ext}${filnamnsprefix}.${fileExtension}`);
                            observer.next(true);
                            observer.complete();
                        },
                        error: error => {
                            observer.next(false);
                            observer.complete();
                        }
                    });
        });
    }
}
